/*
 * @Author: princemwang
 * @Date: 2023-01-17 11:16:17
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-01-17 16:50:21
 */
import { FC, useState, useMemo, useRef, useEffect } from 'react';
import { Bubble, Button } from '@tencent/tea-component';
import './index.css';

export type SpeedValue = '0.8' | '1.0' | '1.2' | '1.5' | '';
interface SpeedOption {
  text: string;
  value: string;
}
interface Props {
  /**
   * @description 音频倍速值
   */
  speedValue?: SpeedValue;
  /**
   * @description 音频倍速change事件
   */
  speedChange?: React.Dispatch<React.SetStateAction<SpeedValue>>;
  /**
   * @description 音频倍速选项
   */
  speedOption?: SpeedOption[];
}
const DoubleSpeed: FC<Props> = ({ speedOption, speedValue, speedChange }) => {
  const isClick = useRef(false);
  const btnRef = useRef(null);
  const [visible, setVisible] = useState(false);
  const activeIndex = useMemo(() => {
    return speedOption.findIndex((ele) => ele.value === speedValue);
  }, [speedValue, speedOption]);
  const listCase = (
    <ul className="speed-option">
      {speedOption.map((ele, index) => (
        <li
          key={ele.value}
          className={activeIndex === index ? 'speed-option-item speed-option-item-active' : 'speed-option-item'}
          onClick={() => {
            isClick.current = true;
            setVisible(false);
            speedChange(ele.value as SpeedValue);
          }}
        >
          {ele.text}
        </li>
      ))}
    </ul>
  );
  const speedText = useMemo(() => {
    let text = '倍速';
    if (isClick.current) {
      text = speedOption.find((ele) => ele.value === speedValue).text;
    }
    return text;
  }, [speedValue, speedOption, isClick]);
  useEffect(() => {
    const documentClick = (e: MouseEvent) => {
      const { target } = e;
      if (btnRef.current !== target && visible) {
        setVisible(false);
      }
    };
    document.addEventListener('click', documentClick);
    return () => {
      document.removeEventListener('click', documentClick);
    };
  }, [btnRef, visible]);
  return (
    <div className="audio-speed">
      <Bubble trigger={'empty'} content={listCase} visible={visible} className="audio-speed-bubble">
        <Button
          type="text"
          className="audio-speed-button"
          onClick={() => {
            setVisible((val) => !val);
          }}
        >
          <span className="speed-btn-text" ref={btnRef} style={{ color: visible ? '#006EFF' : '#333333' }}>
            {speedText}
          </span>
        </Button>
      </Bubble>
    </div>
  );
};
export default DoubleSpeed;
